import { FC } from 'react';
import styled from '@emotion/styled';
import LearnOnTheGo from '@comp/LearnOnTheGo/LearnOnTheGo';
import { SPACING_10B, SPACING_4B } from '@styles/constants/spacings';
import useWindowSize from '@hooks/useWindowSize';
import { breakpoints, Fonts } from '@styles/index';
import NextImage from '@base/Image';

const desktopCombined = 'goal/k12/desktop-combined.svg';
const mobileCombined = 'goal/k12/mobile-combined.svg';
const OuterWrapper = styled.div`
  margin: auto;
  @media (min-width: 71em) {
    position: relative;
    width: 1366px;
  }
  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    max-width: 1024px;
  }
`;

const StyledLearnOnTheGo = styled(LearnOnTheGo)`
  box-shadow: none;
  background-color: transparent;
  @media (min-width: 71em) {
    width: 100%;
    height: 580px;
    margin-top: 0px;
    position: relative;
    grid-template-columns: 39% 57.6%;
    .content {
      padding-left: 115px;
      width: auto;
    }
  }
  @media (min-width: 48em) {
    grid-template-rows: 1fr;
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 45% 51.6%;
    height: 350px;
    overflow: visible;
    .content {
      padding: ${SPACING_4B};
      width: 100%;
      .title {
        font-size: 30px;
      }
      .description {
        font-size: ${Fonts.H6};
        margin-top: ${SPACING_4B};
      }
      .app-links {
        margin-top: ${SPACING_10B};
      }
    }
  }
  @media (max-width: ${breakpoints.mobile}) {
    margin-left: 0;
    height: auto;
    margin-right: 0;
    width: 100%;
    .content {
      text-align: left;
      .title {
        font-size: ${Fonts.H3};
        width: 220px;
      }
    }
    .app-links {
      justify-content: flex-start;
    }
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  margin: 116px 0 0 0;
  @media (max-width: ${breakpoints.tablet}) {
    margin: 0 0 0 15px;
    height: 300px;
    max-width: 450px;
    right: 0;
    width: 100%;
    position: absolute;
  }
  @media (max-width: ${breakpoints.mobile}) {
    position: relative;
    height: 313px;
    margin-left: 15px;
  }
`;
const MobileLaptopImg = styled(NextImage)`
  @media (max-width: ${breakpoints.tablet}) {
    object-fit: cover;
  }
`;

const Fade = styled.div`
  position: absolute;
  width: 120px;
  right: 0px;
  height: 100%;
  top: 0;
  background: linear-gradient(
    270deg,
    var(--color-base-0) 0%,
    rgba(252, 252, 252, 0.5) 51.04%,
    rgba(252, 252, 252, 0) 100%
  );
`;

const dataProps = {
  title: 'Learn on the phone or the computer',
  description:
    'Continue your preparation on any device. Android, iOS or your computer.'
};

const K12LearnOnTheGo: FC = (props) => {
  const { isMobile } = useWindowSize();
  const image = isMobile ? mobileCombined : desktopCombined;
  const imageNode = (
    <ImageWrapper>
      <MobileLaptopImg src={image} alt="k12 learn on the go" layout="fill" />
    </ImageWrapper>
  );
  const content = (
    <StyledLearnOnTheGo
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      imageNode={imageNode}
      learnerTitle={dataProps.title}
      learnerDescription={dataProps.description}
    />
  );
  return isMobile ? (
    content
  ) : (
    <OuterWrapper>
      {content}
      <Fade />
    </OuterWrapper>
  );
};

export default K12LearnOnTheGo;
